import { render } from "./LoginDialogButton.vue?vue&type=template&id=00daebac"
import script from "./LoginDialogButton.vue?vue&type=script&lang=js"
export * from "./LoginDialogButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__